import { cn } from '@ui/lib/utils';
import { Loader2Icon } from 'lucide-react';
import { FC } from 'react';

interface SpinnerProps {
  className?: string;
  containerClassName?: string;
}

export const Spinner: FC<SpinnerProps> = (props) => {
  const { className, containerClassName } = props;
  return (
    <div
      className={cn(
        'flex size-full items-center justify-center',
        containerClassName,
      )}
    >
      <Loader2Icon
        className={cn('m-auto size-10 animate-spin', className)}
        aria-hidden="true"
      />
    </div>
  );
};
